import { t } from "@lingui/core/macro";

import React from "react";

import * as styles from "./Subscribe.module.scss";
import SubscribeInlineForm from "components/SubscribeToNewsletter/SubscribeInlineForm/SubscribeInlineForm";
import { FormDisclaimerFragment } from "types/graphql-types";
import { INavLink } from "components/HeaderNavBar/type";
import { BlockContent } from "components/BlockContent";
import { isPresent } from "src/utils/checks";
import { TokenValues } from "@silversea-ssc/dotcom-read-model-types/Tokens";
import * as OptionalDate from "@silversea-ssc/dotcom-api-types/OptionalDate";
import { isPromoValid } from "components/CustomPromo/promoValidation";
import { SubscribeFormContent } from "components/SubscribeToNewsletter/types";

// WARNING: this is needed because this component is used inside a gatby slice that doens't support lingui react
const generateLabel = () => {
  return t`Subscribe for exclusive <0/>offers and news`.replace(
    "<0/>",
    "<br />"
  );
};

type Props = {
  subscribeFormContent: SubscribeFormContent;
  formDisclaimerContent: FormDisclaimerFragment | undefined;
  privacyPolicyUrl: INavLink;
  offerPageUrl: string | undefined;
  tokens?: TokenValues;
  promoExpirationDate?: OptionalDate.OptionalDate;
  remotePromoCode?: string;
};

const Subscribe: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const isPromoActive =
    isPresent(props.remotePromoCode) &&
    isPresent(props.promoExpirationDate) &&
    isPromoValid(props.remotePromoCode, props.promoExpirationDate);

  const title =
    isPromoActive && props.subscribeFormContent.customHeadingTitle
      ? props.subscribeFormContent.customHeadingTitle
      : props.subscribeFormContent.headingTitle;

  const content =
    isPromoActive && props.subscribeFormContent.customHeadingContent
      ? props.subscribeFormContent.customHeadingContent
      : props.subscribeFormContent.headingContent;

  return (
    <React.Fragment>
      <div className={styles.subscribe}>
        {isPromoActive ? (
          <>
            <div className={styles.titleWithPromo}>
              <label
                htmlFor="footer-subscribe-form"
                dangerouslySetInnerHTML={{ __html: generateLabel() }}
                aria-label={t`Subscribe for exclusive <0/>offers and news`}
              />
            </div>
            <div className={styles.subtitle}>
              <BlockContent
                value={props.subscribeFormContent.footerContent}
                tokens={props.tokens}
              />
            </div>
          </>
        ) : (
          <div className={styles.title}>
            <label
              htmlFor="footer-subscribe-form"
              dangerouslySetInnerHTML={{ __html: generateLabel() }}
              aria-label={t`Subscribe for exclusive <0/>offers and news`}
            />
          </div>
        )}

        <SubscribeInlineForm
          {...props}
          formName="SubscribeToNewsletterFooter"
          formVariant="black"
          formButtonVariant="white"
          formTitle={title}
          formContent={content}
        />
      </div>
    </React.Fragment>
  );
};

export default React.memo(Subscribe);
